export default __webpack_public_path__ + "static/media/arrow.0b01a3de.svg";